let payMethods = {
  lock:false,
  install(Vue){
    Vue.mixin({
      created() {
        window.payCallback = this.payCallback;
      },
      methods: {
        async payCallback(res){
          if(res == 0 || res==9000){
            this.$service.getStatisCommon("evn_paysuccess",{});
            res=1;
            this.$toast("支付成功")
            let aygsobj=JSON.parse(this.$route.query.args);
            let redData={
              params:{
                orderId:aygsobj.orderId
              }
            }
            let ress =await this.$service.paying(redData);
            if(ress.result){
              localStorage.setItem(this.$env+"backpop","ok");
              this.$router.replace({path: "/orderList",query:{payRes:res}})
            }
            
          }else{
            res=2;
            // this.$toast("支付失败")
            localStorage.setItem(this.$env+"backpop","ok");
            this.$router.replace({path: "/orderList",query:{payRes:res}})
          }
        }
      }
    })
    Vue.prototype.$onlinePayment = async function(orderId){
      // this.isSale = false;
      let params = {
        jsCode: localStorage.getItem(this.$env+"jsCode") || "",
        customerId: localStorage.getItem(this.$env+"memberId") || "",
        orderId: orderId,
        paymentMethod: 11
      }
      if(this.$platform === "miniProgram"){
        this.$miniPay(orderId)
      }else{
        // this.$appPay(params)
        if(this.$route.path=="/orderConfirm"){
          this.$router.replace({ path: '/checkout', query: {args:JSON.stringify(params),orderId:orderId}})
        }else{
          this.$router.push({ path: '/checkout', query: {args:JSON.stringify(params),orderId:orderId}})
        }
      }
    },

    Vue.prototype.$appPay = async function(params){
      try{
        let toast=this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let res = await this.$service.onlinePayment(params);
        if(res.result.codeUrl){
          toast.close();
          let codeUrl=res.result.codeUrl;
          if(params.paymentMethod==37){//微信支付
            payMethods.getWechartPay(codeUrl)
          }else if(params.paymentMethod==55){//支付宝支付
            payMethods.getAliPay(codeUrl)
          }
        }
      }catch(e){
        this.buttonClicked= false;
        if(e.message==undefined){
          this.$toast("支付失败:请检查网络后重试")
        }else{
          this.$toast(`支付失败:${e.message}`)
        }
      }
    },
    
    Vue.prototype.$miniPay = async function(orderId){
      // this.$wx.miniProgram.navigateTo({
      //   url: "../wxPay/wxPay?orderId="+orderId
      // })
      if(payMethods.lock){
        return
      }
      payMethods.lock=true;
      this.$wx.miniProgram.redirectTo({
        url: `../wxPay/wxPay?orderId=${orderId}`
      })
    }
  },
  
  getWechartPay(params){
    console.log(params)
    // let str = JSON.stringify(params)
    window.android.wechartPay(params)
  },
  getAliPay(params){
    console.log(params)
    // let str = JSON.stringify(params)
    window.android.aliPay(params)
  },
}


export default payMethods